<template>
  <v-card>
    <v-card-title>
      <div>{{ title }}</div>
      <v-spacer></v-spacer>
      <div>
        <v-select
          v-model="localCoinId"
          class="select-wrap"
          flat
          single-line
          dense
          outlined
          item-text="label"
          item-value="value"
          :items="coinList"
          :menu-props="{ offsetY: true }"
        ></v-select>
      </div>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="data.records"
      :no-data-text="$t('common.noRecords')"
      :server-items-length="data.total"
      :page="paginationConfig.current"
      :items-per-page="paginationConfig.size"
      mobile-breakpoint="0"
      @update:page="pageChg"
      @update:items-per-page="itemsPerPageChg"
      :footer-props="{'items-per-page-text': $t('common.rowPerPage')}"
    >
      <template v-slot:item.created="{ item }">
        {{ setTimeZone(item.created) }}
      </template>
      <template v-slot:item.businessType="{ item }">
        {{ businessType[item.businessType] }}
      </template>
      <template v-slot:item.assetType="{ item }">
        <div class="color-buy" v-if="item.assetType == 1">{{ $t('labels.transaction.availableAsset') }}</div>
        <div class="color-sell" v-else>{{ $t('labels.transaction.freezeAsset') }}</div>
      </template>
      <template v-slot:item.businessSubType="{ item }">
        {{ businessSubType[item.businessSubType] }}
      </template>
      <template v-slot:item.changeAmount="{ item }">
        <div class="color-buy" v-if="item.paymentType == 1">+ {{ item.changeAmount }}</div>
        <div class="color-sell" v-else>- {{ item.changeAmount }}</div>
      </template>
      <template v-slot:item.fee="{ item }">
        <div class="color-sell" v-if="item.fee > 0">- {{ item.fee }}</div>
        <div v-else> - </div>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    businessType: {
      type: Object,
      default: () => {
        return {};
      }
    },
    businessSubType: {
      type: Object,
      default: () => {
        return {};
      }
    },
    coinId: {
      type: [String, Number],
      default: ''
    },
    coinList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    data: {
      type: Object,
      default: () => {
        return {};
      }
    },
    paginationConfig: {
      type: Object,
      default: () => {
        return {};
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    localCoinId: {
      get() {
        return this.coinId;
      },
      set(val) {
        this.$emit('update:coinId', val);
      }
    }
  },
  data() {
    return {
      search: '',
      headers: [
        { text: this.$t('labels.transaction.time'), value: 'created', width: '160', sortable: false },
        { text: this.$t('labels.transaction.coin'), value: 'coinName', width: '100', sortable: false },
        { text: this.$t('labels.transaction.id'), value: 'orderId', width: '130', sortable: false },
        { text: this.$t('labels.transaction.type'), value: 'businessType', width: '100', sortable: false },
        { text: this.$t('labels.transaction.assetType'), value: 'assetType', width: '130', sortable: false },
        { text: this.$t('labels.actions'), value: 'businessSubType', width: '150', sortable: false },
        { text: this.$t('labels.transaction.beforeAmount'), value: 'beforeAmount', width: '150', sortable: false },
        { text: this.$t('labels.transaction.changeAmount'), value: 'changeAmount', width: '130', sortable: false },
        { text: this.$t('labels.transaction.afterAmount'), value: 'afterAmount', width: '150', sortable: false },
        { text: this.$t('labels.transaction.fee'), value: 'fee', width: '130', sortable: false }
      ]
    };
  },
  methods: {
    pageChg(val) {
      const data = {
        current: val,
        size: this.paginationConfig.size
      };
      this.$emit('update:paginationConfig', data);
    },
    itemsPerPageChg(val) {
      const data = {
        current: this.paginationConfig.current,
        size: val
      };
      this.$emit('update:paginationConfig', data);
    }
  }
};
</script>
<style lang="stylus" scoped>
.v-data-table::v-deep {
  thead {
    th {
      height: 35px;
      padding: 0 10px;
    }
  }
  tbody {
    td {
      font-size: 0.8rem;
      height: 35px;
      padding: 0 10px;
    }
  }
}
.v-select.select-wrap::v-deep {
  .v-input__control {
    .v-input__slot {
      margin-bottom: 0;
      min-height: 35px;
      .v-select__selections {
        .v-select__selection {
          font-size: 0.85rem;
          max-width: 100%;
        }
        input {
          display: none;
        }
      }
      .v-input__append-inner {
        align-self: unset;
        margin-top: 0px;
        i {
          margin-top: 0px;
        }
      }
    }
    .v-text-field__details {
      display: none;
    }
  }
}

@media screen and (max-width: 599px) {
 .v-data-table::v-deep {
    .v-data-footer {
      justify-content: center;
      padding-top: 10px;

      .v-data-footer__select {
        order: 4;
        margin: 0 200px;
      }

      .v-data-footer__pagination {
        order: 2;
      }

      .v-data-footer__icons-before {
        order: 1;
      }

      .v-data-footer__icons-after {
        order: 3;
      }
    }
  }
}
</style>
